import { LinearProgress, LinearProgressProps } from '@mui/material';
import { Box } from '@mui/system';

export const ProgressBar = (props: LinearProgressProps & { value: number }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" color="primary" {...props} sx={{ height: 20 }} />
      </Box>
    </Box>
  );
};
